import {
    ApiBaseService,
    type PaginatedFetch,
    type PaginatedFetchOptions,
} from "./ApiBaseService";
import type { FormResponse } from "~/models/Form";
import type { ApiResponse } from "~/types/ApiResponse";

export default class FormResponseService extends ApiBaseService {
    public list(
        options?: Partial<PaginatedFetchOptions>,
    ): PaginatedFetch<FormResponse[]> {
        return this.paginate<FormResponse[]>(
            this.route("api.responses.index", "/responses"),
            options as PaginatedFetchOptions,
        );
    }

    public find(id: string): Promise<ApiResponse<FormResponse>> {
        return this.request(
            this.route("api.responses.show", "/responses/{response}", {
                response: id,
            }),
        );
    }

    public delete(id: string): Promise<null> {
        return this.request(
            this.route("api.responses.destroy", "/responses/{response}", {
                response: id,
            }),
            {
                method: "DELETE",
            },
        );
    }
}
